// extracted by mini-css-extract-plugin
module.exports = {"description":"RehY5rTL"};